import { Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../../components/auth/AuthProvider';

function AdminLinkCard({ title, description, links }) {
  return (
    <Card className="h-100">
      <Card.Header>
        <strong>{title}</strong>
      </Card.Header>
      <Card.Body>
        {description && <p className="text-muted small mb-2">{description}</p>}
        <ul className="list-unstyled mb-0">
          {links.map((link, i) => (
            <li key={i} className="mb-1">
              {link.external ? (
                <a href={link.path}>{link.title}</a>
              ) : (
                <Link to={link.path}>{link.title}</Link>
              )}
              {link.description && (
                <span className="text-muted small d-block">{link.description}</span>
              )}
            </li>
          ))}
        </ul>
      </Card.Body>
    </Card>
  );
}

function AdminHome() {
  const { allowedSections, hasPermission } = useAuth();

  const hasOrg = allowedSections.some(s => s.path === '/app/org');
  const hasTeam = allowedSections.some(s => s.path?.startsWith('/app/org/teams/'));
  const teamSection = allowedSections.find(s => s.path?.startsWith('/app/org/teams/'));
  const isServicesAdmin = hasPermission('servicios_admin');
  const isDocumentosAdmin = hasPermission('documentos_admin');
  const isRolesAdmin = hasPermission('roles_admin');
  const isPermisosAdmin = hasPermission('permisos_admin');

  const categories = [];

  // General
  categories.push({
    title: 'General',
    links: [
      { path: '/app', title: 'Dashboard', description: 'Resumen de actividad y estadísticas.' },
    ],
  });

  // Organización
  if (hasOrg) {
    const orgLinks = [
      { path: '/app/org', title: 'Estructura organizacional', description: 'Ver regiones, diócesis y comunidades.' },
      { path: '/app/members', title: 'Miembros', description: 'Lista de miembros registrados.' },
    ];
    if (hasTeam && teamSection) {
      orgLinks.push({ path: teamSection.path, title: 'Mi Equipo', description: 'Ver y gestionar mi equipo.' });
    }
    categories.push({ title: 'Organización', links: orgLinks });
  }

  // Contenido
  const contentLinks = [];
  if (isDocumentosAdmin) {
    contentLinks.push({
      path: '/app/admin/documentos',
      title: 'Biblioteca de Documentos',
      description: 'Administrar grupos y archivos de la biblioteca.',
    });
  }
  if (isServicesAdmin) {
    contentLinks.push({
      path: '/app/admin/servicios',
      title: 'Servicios',
      description: 'Administrar servicios y sus documentos.',
    });
  }
  if (isDocumentosAdmin) {
    contentLinks.push({
      path: '/app/admin/home-carousel',
      title: 'Carrusel de Inicio',
      description: 'Subir y eliminar imágenes del carrusel de la página principal.',
    });
  }
  if (contentLinks.length) {
    categories.push({ title: 'Contenido', links: contentLinks });
  }

  // Administración avanzada
  if (isRolesAdmin || isPermisosAdmin) {
    categories.push({
      title: 'Administración avanzada',
      links: [
        {
          path: '/app/admin/roles',
          title: 'Roles y Permisos',
          description: 'Crear roles, crear permisos y asignar permisos a roles.',
        },
      ],
    });
  }

  return (
    <Container className="py-4">
      <h1 className="mb-4">Administración</h1>
      <Row xs={1} sm={2} lg={3} className="g-4">
        {categories.map((cat, i) => (
          <Col key={i}>
            <AdminLinkCard title={cat.title} description={cat.description} links={cat.links} />
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default AdminHome;
